import { render } from "./IsoVoyageJordan.vue?vue&type=template&id=76c1d71e"
import script from "./IsoVoyageJordan.vue?vue&type=script&lang=js"
export * from "./IsoVoyageJordan.vue?vue&type=script&lang=js"

import exportComponent from "/home/ammar/Downloads/inso_app/isoassurance/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__